import React, { useEffect } from 'react';
import { Card, Col, Row, Typography, Button, Breadcrumb, Space, Alert, Divider, notification, Empty } from 'antd';
import { BankOutlined, FilePdfOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCourseMutation } from '../slices/usersApiSlice';
import { setCourse } from '../slices/courseSlice';

const { Title, Paragraph } = Typography;

const CoursesScreen = () => {
  const [api, contextHolder] = notification.useNotification();
  const [getCourse, { isLoading: isCalculationLoading }] = useGetCourseMutation();
  const { darkmode } = useSelector((state) => state.darkmode);
  const {course} = useSelector((state) => state.course)
  const dispatch = useDispatch();

  const getCourses = async (startDate, endDate) => {
    try {
      const res = await getCourse().unwrap();
      dispatch(setCourse({ ...res }));
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
}
useEffect(()=> {
  getCourses()
  console.log(course);
},[])


  return (
    <div >
      {contextHolder}
      <Title level={2}   style={{ fontFamily: 'Inter, sans-serif', }}><BankOutlined/> Courses</Title>
      <Row  style={{padding: "20px", backgroundColor: darkmode ? "#141414" : "white", borderRadius: "5px"}}>    
        <Col flex={"auto"}>
          <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Earn More Varsity' }, { title: 'Courses' }]} style={{marginBottom: "5px"}} />
        </Col>     
      </Row>
      <Divider/>
      <Alert style={{marginBottom: "10px"}} message="Welcome to Earn More Varsity" description={"Earn More Varsity is a dedicated platform focused on providing educational resources for traders at every skill level. Their collection of PDF courses covers essential topics, from foundational concepts to advanced strategies, helping individuals build a solid knowledge base and make informed trading decisions. These resources are designed to cater to both beginners and experienced traders looking to deepen their expertise."} type="success" showIcon></Alert>

      <Row gutter={[16, 16]}>
        {course != null && course.course.length > 0 ? (
        <>  
          {course.course.map((cours) => (
            <Col xs={24} sm={12} md={8} lg={6} key={cours.id}>
              <Card
                hoverable
                title={cours.title}
                bordered={false}
                loading={isCalculationLoading}
                actions={[
                  <Button
                    type="primary"
                    icon={<FilePdfOutlined />}
                    onClick={() => window.open(cours.pdf, '_blank')}
                  >
                    Open PDF
                  </Button>,
                ]}
              >
                <Paragraph ellipsis={{ rows: 3 }}>{cours.content}</Paragraph>
              </Card>
            </Col>
          ))}
        </>
        ):(
          <Card>
            <Empty/>
          </Card>
        )}
      </Row>
    </div>
  );
};

export default CoursesScreen;
